import { render, staticRenderFns } from "./BannerShortcutForm.vue?vue&type=template&id=cf4204e8&scoped=true&"
import script from "./BannerShortcutForm.vue?vue&type=script&lang=js&"
export * from "./BannerShortcutForm.vue?vue&type=script&lang=js&"
import style0 from "./BannerShortcutForm.vue?vue&type=style&index=0&id=cf4204e8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf4204e8",
  null
  
)

export default component.exports